import type { NodeData } from '@ipfabric/utils';
import { setNodePositions } from 'components/Graph/commands/setNodePositions';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { getSelectedNodes } from 'components/Graph/model/GraphData';
import type { Direction } from 'utils/types/Direction';

export interface AlignSelectedNodesCommand {
  direction: Direction;
}

export const alignSelectedNodes: GraphCommandFactory<
  AlignSelectedNodesCommand
> = (cmdContext, dispatch) => (command) => {
  const { graph } = cmdContext.getState();
  const selectedNodes = getSelectedNodes(graph);
  if (selectedNodes.length === 0) {
    return;
  }
  const maxCoordinate = selectedNodes.reduce<number | null>(
    (result, nodeData) => getMaxCoordinate(nodeData, result, command.direction),
    null,
  )!;
  const positions = selectedNodes.map(({ id: nodeId }) => ({
    nodeId,
    moveTo: {
      [getDirectionKey(command.direction)]: maxCoordinate,
    },
  }));
  dispatch(setNodePositions, { positions });
};

function getDirectionKey(direction: Direction): 'x' | 'y' {
  return direction === 'up' || direction === 'down' ? 'y' : 'x';
}

function getMaxCoordinate(
  node: NodeData,
  currentMax: number | null,
  direction: Direction,
): number {
  const coord = node.position[getDirectionKey(direction)];
  if (currentMax === null) {
    return coord;
  }
  return direction === 'up' || direction === 'left'
    ? Math.min(coord, currentMax)
    : Math.max(coord, currentMax);
}
